import { render, staticRenderFns } from "./PassengerTransportationPermissionTable.vue?vue&type=template&id=eeb70cbe&scoped=true"
import script from "./PassengerTransportationPermissionTable.vue?vue&type=script&lang=ts"
export * from "./PassengerTransportationPermissionTable.vue?vue&type=script&lang=ts"
import style0 from "./PassengerTransportationPermissionTable.vue?vue&type=style&index=0&id=eeb70cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb70cbe",
  null
  
)

export default component.exports